
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeavePolicyDialog extends Serenity.EntityDialog<LeavePolicyRow, any> {
        protected getFormKey() { return LeavePolicyForm.formKey; }
        protected getIdProperty() { return LeavePolicyRow.idProperty; }
        protected getLocalTextPrefix() { return LeavePolicyRow.localTextPrefix; }
        protected getNameProperty() { return LeavePolicyRow.nameProperty; }
        protected getService() { return LeavePolicyService.baseUrl; }
        protected getDeletePermission() { return LeavePolicyRow.deletePermission; }
        protected getInsertPermission() { return LeavePolicyRow.insertPermission; }
        protected getUpdatePermission() { return LeavePolicyRow.updatePermission; }

        protected form = new LeavePolicyForm(this.idPrefix);

    }
}